'use strict';

let routes = function ($stateProvider, baseState) {

    $stateProvider

        .state('' + baseState + '.supporting-documents', {
            abstract: true,
            url: "/supporting-documents",
            template: require("./inspect.supporting-documents.html"),
        })

        .state('' + baseState + '.supporting-documents.receipts-and-proof-of-events', {
            url: "/receipts-and-proof-of-events",
            template: require("./inspect.receipts-and-proof-of-events.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel1: /*@ngInject*/ function (setRouteBasedVisibilitySettingsLevel0, routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkSupportingDocument_columns_by_step = 'supporting-documents.relevance';
                }
            }
        })

        // "Attributes"
        .state('' + baseState + '.supporting-documents.curate', {
            url: "/attributes",
            data: {
                pageTitle: 'Curate Supporting Document - Step \'attributes\'',
                stepCaption: "Attributes",
                stepMetadata: {"stepReference": "attributes", "step": "attributes"},
            },
            template: require("crud/clerk-supporting-document/curate-steps/attributes.html"),
            controller: "listClerkSupportingDocumentsController",
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkSupportingDocument_columns_by_step = 'supporting-documents.relevance';
                },
            }
        })

    ;

};

let loadRoutesLazily = function ($stateProvider, baseState) {

    let lazyStateProvider = {
        states: [],
        state: function (name, stateConfig) {
            let state = angular.merge({name: name}, stateConfig);
            this.states.push(state);
            return this;
        }
    };
    routes(lazyStateProvider, baseState);
    $stateProvider.state(baseState + '.supporting-documents.**', {
        url: "/supporting-documents",
        lazyLoad: function ($transition$, ParentService) {
            return lazyStateProvider;
        },
    });

};

export default {
    routes: routes,
    loadRoutesLazily: loadRoutesLazily,
};



// WEBPACK FOOTER //
// .-dna/app/subsections/supporting-documents/supporting-documents.js